// extracted by mini-css-extract-plugin
export var alignCenter = "_5q-d";
export var bannerShown = "_5q-6";
export var buttonContent = "_5q-0";
export var cardList = "_5q-1";
export var centerContent = "_5q-2";
export var chevron = "_5q-3";
export var closePanelButton = "_5q-k";
export var conversationContextContainer = "_5q-l";
export var conversationDetailContainer = "_5q-4";
export var detailWrapper = "_5q-7";
export var dropdownButton = "_5q-e";
export var dropdownTitle = "_5q-9";
export var fullHeight = "_5q-5";
export var hidden = "_5q-a";
export var icon = "_5q-b";
export var mergeSuggestionWrapper = "_5q-m";
export var panel = "_5q-i";
export var portalButtonsWrapper = "_5q-c";
export var right = "_5q-j";
export var tableSummaryContainer = "_5q-8";
export var tableSummaryHeader = "_5q-g";
export var threeDotsButton = "_5q-f";
export var wide = "_5q-h";